import { CheckCircle, WarningCircle } from '@phosphor-icons/react';
import { useIslandState } from '../IslandProvider';
import { anzuzeigendeAktivitaet } from '../island-state';
import { FARBE, getoent } from '../pille-stil';

/** Fortschrittsring 24 px (Prototyp: Spur .16, Fortschritt Gold); ohne Prozent dreht er sich. */
export function Fortschrittsring({ prozent }: { prozent: number | undefined }) {
  const umfang = 2 * Math.PI * 9.5;
  const unbestimmt = prozent === undefined;
  const p = unbestimmt ? 28 : Math.max(0, Math.min(100, prozent));
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" aria-hidden className={unbestimmt ? 'pille-dreh' : undefined}
      style={{ transform: unbestimmt ? undefined : 'rotate(-90deg)', flexShrink: 0 }}>
      <circle cx={12} cy={12} r={9.5} fill="none" stroke="rgba(255,255,255,0.16)" strokeWidth={3} />
      <circle cx={12} cy={12} r={9.5} fill="none" stroke={FARBE.gold} strokeWidth={3} strokeLinecap="round"
        strokeDasharray={`${(umfang * p) / 100} ${umfang}`} style={{ transition: 'stroke-dasharray .3s ease' }} />
    </svg>
  );
}

/** Aktivität (Handoff Pille §3): Fortschrittsring + Label + Prozent; nach Abschluss Haken bzw. Warnung. */
export function LiveContent() {
  const { activities } = useIslandState();
  const a = anzuzeigendeAktivitaet(activities);
  if (!a) return null;
  const fertig = a.status !== 'running';
  const farbe = a.status === 'error' ? FARBE.rotHell : FARBE.gruen;
  return (
    <div role="status" aria-live="polite" className="flex h-full items-center" style={{ gap: 10, padding: '0 10px 0 12px' }}>
      {fertig
        ? (a.status === 'error' ? <WarningCircle size={24} weight="fill" color={farbe} /> : <CheckCircle size={24} weight="fill" color={farbe} />)
        : <Fortschrittsring prozent={a.progress} />}
      <span className="min-w-0 flex-1 truncate" style={{ fontSize: 13, fontWeight: 700 }}>{a.label}</span>
      {!fertig && a.progress !== undefined && (
        <span className="shrink-0 tabular-nums" style={{ height: 28, padding: '0 10px', borderRadius: 14, fontSize: 12, fontWeight: 800, lineHeight: '28px', background: getoent(FARBE.gold, 0.18), color: FARBE.gold }}>
          {Math.round(a.progress)} %
        </span>
      )}
    </div>
  );
}
